export const UserRole = {
  SUPER_ADMIN: 'super_admin',
  ORG_ADMIN: 'org_admin',
  COMPANY_ADMIN: 'company_admin',
  ANALYST: 'analyst',
  VIEWER: 'viewer',
} as const

export type UserRole = (typeof UserRole)[keyof typeof UserRole]

export interface User {
  id: string
  email: string
  full_name: string
  role: UserRole
  is_active: boolean
  organization_id: string | null
  last_login_at: string | null
  created_at: string
  // SA-3: solo para decidir si el frontend ofrece navegación a
  // /super-admin — la autorización real vive en el backend
  // (require_platform_operator), nunca confiar solo en este flag aquí.
  is_platform_operator: boolean
}

export interface TokenResponse {
  access_token: string
  refresh_token: string
  token_type: string
  expires_in: number
}

export interface LoginPayload {
  email: string
  password: string
}

export interface AuthSession {
  accessToken: string
  refreshToken: string
  /** Epoch ms del vencimiento estimado del access token. */
  expiresAt: number
}
